export enum ReferralCodeEnum {
  ReferralCodeShare1 = 'Bonus dla moich znajomych!',
  ReferralCodeShare2 = 'do każdego ubezpieczenia w porównywarce Mubi. Korzystajcie!',
}
